module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms2_m_en.347705ad47979242b322acad18dd1f24.png";